<script setup lang="ts">
import { getCertificationImageSrc } from '@/helpers/CertificationsHelper';
import { getStars } from '@/helpers/RatingHelper';
import { CertificationType, PublicCustomerProfile } from '@/models/backend/CustomerModels';
import { ref, defineProps, watch } from 'vue';
import { CustomerProfileService } from '@/services/backend/CustomerService';
import { showExceptionAlert } from '@/helpers/SweetAlertHelper';

const props = defineProps<{
  userId: string
}>();
const userInfo = ref({} as PublicCustomerProfile);
const isLoading = ref<boolean>(false);

const getUserInfo = async () => {
	try {
        isLoading.value = true;
		
        const response = await CustomerProfileService.getPublicCustomerProfile(props.userId);
        if(response!=null){
            userInfo.value = response;
        }

	} catch (error) {
		showExceptionAlert(error);
	} finally {
        isLoading.value = false;
    }
}

watch(() => props.userId, () => {
    getUserInfo()
}, { deep: true, immediate: true });

</script>
<template>
    <div class="top-content">
        <span class="user-name">{{ userInfo.name }}</span>
        <span class="verified">verificado<i class="bp-icon-Verified"></i></span>
    </div>
    <section class="user-info">
        <div class="field">
            <span class="field-label">Nombre</span>
            <span class="field-value">{{ userInfo.name }}</span>
        </div>
        <!-- <div class="field">
            <span class="field-label">Empresa</span>
            <span class="field-value">{{ userInfo.companyName }}</span>
        </div> -->
        <div class="field">
            <span class="field-label">Código postal</span>
            <span class="field-value">{{ userInfo.postalCode }}</span>
        </div>
        <div class="field" v-if="userInfo.certifications">
            <span class="field-label">Acreditaciones:</span>
            <ul class="credentials-list">
                <li v-if="userInfo.certifications.includes(CertificationType.ISO9001)"><img class="cert-img" :src="getCertificationImageSrc(CertificationType.ISO9001)" :alt="CertificationType.ISO9001" /></li>
                <li v-if="userInfo.certifications.includes(CertificationType.ISO14001)"><img class="cert-img" :src="getCertificationImageSrc(CertificationType.ISO14001)" :alt="CertificationType.ISO14001" /></li>
                <li v-if="userInfo.certifications.includes(CertificationType.ANREPA)"><img class="cert-img" :src="getCertificationImageSrc(CertificationType.ANREPA)" :alt="CertificationType.ANREPA" /></li>
                <li v-if="userInfo.certifications.includes(CertificationType.EPAL)"><img class="cert-img" :src="getCertificationImageSrc(CertificationType.EPAL)" :alt="CertificationType.EPAL" /></li>
                <li v-if="userInfo.certifications.includes(CertificationType.NIMA)"><img class="cert-img" :src="getCertificationImageSrc(CertificationType.NIMA)" :alt="CertificationType.NIMA" /></li>
            </ul>
        </div>
    </section>
    <section class="rating-container">
        <h3 class="h3-title">Valoraciones</h3>
        <img class="stars" :src="getStars((userInfo.rating) ? userInfo.rating : 0)" alt="Valoración" />
    </section>
</template>
<style scoped lang="scss">
@import 'UserInfoComponent.scss';
</style>